import { connect } from 'react-redux';
import * as actions from '../../actions';
import { RememberMe } from '@imprivata/nucleus';

/**
 * RememberMe Component for Skip Second Factor
 * Allows the user to enable skip second factor for future authentications on
 * the same device.
 */
/**
 * The allowed properties for the RememberMe component
 * @param {bool} canOptInToSkipSecondFactor whether or not the component should be shown
 * @param {bool} enableSkipSecondFactor whether or not the checkbox is enabled
 *    and therefore the user is opting it to skip second factor
 * @param {function} toggleSkipSecondFactor set a flag whether or not to save the token
 */

const mapStateToProps = state => {
  const {
    canOptInToSkipSecondFactor, enableSkipSecondFactor, skipSecondFactorPeriod,
  } = state.login;
  return {
    canOptInToSkipSecondFactor,
    enableSkipSecondFactor,
    skipSecondFactorPeriod,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSkipSecondFactor: toggleState => {
      /* istanbul ignore next */
      dispatch(actions.toggleSkipSecondFactor(toggleState) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RememberMe);
